// Google Doc where we document this stuff for all MikMak team members to see.
// https://docs.google.com/spreadsheets/d/1OV3xqG3cUMRw2Y70ugIBldchXTLqiyYKvwT_hK21kyY/

export default {
  'pageView': 'PAGE_VIEW',
  'getFromFirebaseServiceError': 'GET_FROM_FIREBASE_SERVICE_ERROR',

  'attachPlayerCreated': 'ATTACH_PLAYER_CREATED',
  'attachPlayerUpdated': 'ATTACH_PLAYER_UPDATED',
  'attachPlayerBuildError': 'ATTACH_PLAYER_BUILD_ERROR',
  'brandCreated': 'BRAND_CREATED',
  'brandUpdated': 'BRAND_UPDATED',
  'errorCreatingReport': 'ERROR_CREATING_REPORT',
  'assetSizeExceedsLimit': 'ASSET_SIZE_EXCEEDS_LIMIT',

  'selfServeUserSelectedFormOption': 'SELF_SERVE_USER_SELECTED_FORM_OPTION',
  'selfServeUserCopiedLink': 'SELF_SERVE_USER_COPIED_LINK',
  'bulkLinksGenerated': 'BULK_LINKS_GENERATED',
  'mediaPlanCSVDownloaded': 'MEDIA_PLAN_CSV_DOWNLOADED',
  'mediaPlanCSVDownloadFailed': 'MEDIA_PLAN_CSV_DOWNLOAD_FAILED',
  'selfServeUserStartedBuilding': 'SELF_SERVE_USER_STARTED_BUILDING',
  'userCopiedInventoryReport': 'INVENTORY_REPORT_COPIED',
  'newMasterListItemCreated': 'NEW_MASTER_LIST_ITEM_CREATED',

  'bulkAddedCustomRedirects': 'BULK_ADDED_CUSTOM_REDIRECTS',
  'bulkCustomRedirectsError': 'BULK_CUSTOM_REDIRECTS_ERROR',
  'brandProductsUploadFailed': 'BRAND_PRODUCTS_UPLOAD_FAILED',
  'brandProductsUploadStarted': 'BRAND_PRODUCTS_UPLOAD_STARTED',
  'brandProductsUploadCompleted': 'BRAND_PRODUCTS_UPLOAD_COMPLETED',
  'editBrandProductSelected': 'EDIT_BRAND_PRODUCT_SELECTED',
  'brandProductEdited': 'BRAND_PRODUCT_EDITED',
  'retailerPdpUrlAddedToBrandProduct': 'RETAILER_PDP_URL_ADDED_TO_BRAND_PRODUCT ',
  'retailerProductAddedToBrandProduct': 'RETAILER_PRODUCT_ADDED_TO_BRAND_PRODUCT',
  'retailerProductAddedToBrandProductFailed': 'RETAILER_PRODUCT_ADDED_TO_BRAND_PRODUCT_FAILED',
  'brandProductNameUpdated': 'BRAND_PRODUCT_NAME_UPDATED',
  'brandProductAssetUpdated': 'BRAND_PRODUCT_ASSET_UPDATED',
  'productArchived': 'PRODUCT_ARCHIVED',
  'discoverSettingsOpened': 'DISCOVER_SETTINGS_OPENED',
  'discoverSettingsSaved': 'DISCOVER_SETTINGS_SAVED',
  'discoverZipCodeOverride': 'DISCOVER_ZIP_CODE_OVERRIDE',
  'discoverZipCodeOverrideCleared': 'DISCOVER_ZIP_CODE_OVERRIDE_CLEARED',
  'discoverStoreFinderOverride': 'DISCOVER_STORE_FINDER_OVERRIDE',
  'discoverStoreFinderOverrideCleared': 'DISCOVER_STORE_FINDER_OVERRIDE_CLEARED',
  'discoverRetailerOverride': 'DISCOVER_RETAILER_OVERRIDE',
  'discoverRetailerOverrideCleared': 'DISCOVER_RETAILER_OVERRIDE_CLEARED',
  'editViewSelected': 'EDIT_VIEW_SELECTED',
  'editViewSaved': 'EDIT_VIEW_SAVED',
  'viewDuplicated': 'VIEW_DUPLICATED',
  'viewArchived': 'VIEW_ARCHIVED',
  'generateViewLinkClicked': 'GENERATE_VIEW_LINK_CLICKED',
  'adPlatformSlideOutOpened': 'AD_PLATFORM_SLIDEOUT_OPENED',
  'productUnarchived': 'PRODUCT_UNARCHIVED',

  'amazonSalesSignUpError': 'AMAZON_SALES_SIGN_UP_ERROR',

  // marketing widget events
  'marketingWidgetLoadStarted': 'MARKETING_WIDGET_LOAD_STARTED',
  'marketingWidgetInitialized': 'MARKETING_WIDGET_INITIALIZED',
  'marketingWidgetLoadError': 'MARKETING_WIDGET_LOAD_ERROR',

  // user management events
  'userManagementUpdateUserError': 'USER_MANAGEMENT_UPDATE_USER_ERROR',
  'userManagementGetAuth0UserError': 'USER_MANAGEMENT_GET_AUTH0_USER_ERROR',

  // data management events
  'salesDataUpdatedByUser': 'SALES_DATA_UPDATED_BY_USER',
};
